import CommonState from '@/class/cargo/model/parameters/CommonState'
import YeJiGuanLiJiaShiCang from '@/assets/bi/YeJiGuanLiJiaShiCang.jpg'
import GongZuoLiangGuanKongJiaShiCang from '@/assets/bi/GongZuoLiangGuanKongJiaShiCang.jpg'
import HaiYunFengXianGuanKongJiaShiCang from '@/assets/bi/HaiYunFengXianGuanKongJiaShiCang.jpg'
import HuoLiangTongJiJiaShiCang from '@/assets/bi/HuoLiangTongJiJiaShiCang.jpg'
import ZiJinGuanLiJiaShiCang from '@/assets/bi/ZiJinGuanLiJiaShiCang.jpg'
import ZiJinTongJiJiaShiCang from '@/assets/bi/ZiJinTongJiJiaShiCang.jpg'

// 默认仪表盘及图片
export const ZiJinGuanLi = new CommonState(ZiJinGuanLiJiaShiCang, '资金管理驾驶舱', 'Financial Management Cockpit')
export const ZiJinTongJi = new CommonState(ZiJinTongJiJiaShiCang, '资金统计驾驶舱', 'Financial statistics cockpit')
export const YeJiGuanLi = new CommonState(YeJiGuanLiJiaShiCang, '业绩管理驾驶舱', 'Performance management cockpit')
export const HuoLiangTongJi = new CommonState(HuoLiangTongJiJiaShiCang, '货量统计驾驶舱', 'Cargo volume statistics cockpit')
export const GongZuoLiangGuanKong = new CommonState(GongZuoLiangGuanKongJiaShiCang, '工作量管控驾驶舱', 'Workload control cockpit')
export const HaiYunFengXianGuanKong = new CommonState(HaiYunFengXianGuanKongJiaShiCang, '海运风险管控驾驶舱', 'Marine risk control cockpit')

export const DEFAUTL_JIA_SHI_CANG = [ZiJinGuanLi, ZiJinTongJi, YeJiGuanLi, HuoLiangTongJi, GongZuoLiangGuanKong, HaiYunFengXianGuanKong]

/**
 * 根据名称获取图片
 * @param name
 * @returns {string|*}
 */
export function getCodeByName(name) {
  if (name) {
    for (const common of DEFAUTL_JIA_SHI_CANG) {
      if (common.chineseName === name || common.englishName === name) {
        return common.code
      }
    }
  }
  return ''
}

/**
 * 根据名称判断是否存在
 * @param name
 * @returns {boolean}
 */
export function isFreeCustomer(name) {
  if (name) {
    for (const common of DEFAUTL_JIA_SHI_CANG) {
      if (common.chineseName === name || common.englishName === name) {
        return true
      }
    }
  }
  return false
}
